module.exports = __webpack_public_path__ + "img/20190529162416QQ截图20190527165011.28ff9ad6.png";